import { Component } from '@angular/core';
import {Title} from '@angular/platform-browser';
import {Router, NavigationEnd, ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-title',
  template: '<span></span>'
})
export class TitleComponent {
  constructor(private router: Router, private route: ActivatedRoute, private titleService: Title) {
    this.router.events
      .filter(event => event instanceof NavigationEnd)
      .subscribe(() => {
        let currentRoute = this.route.root;
        let title = '';
        do {
          const childrenRoutes = currentRoute.children;
          currentRoute = null;
          childrenRoutes.forEach(routes => {
            if (routes.outlet === 'primary') {
              title = routes.snapshot.data.breadcrumb;
              currentRoute = routes;
            }
          });
        } while (currentRoute);
        this.titleService.setTitle( 'SUNUPROJET | ' + title );
        if (typeof sessionStorage.getItem('rowidsp') === 'object' || sessionStorage.getItem('rowidsp') === null ||
            typeof sessionStorage.getItem('prenomsp') === 'object' || sessionStorage.getItem('prenomsp') === null ||
            typeof sessionStorage.getItem('nomsp') === 'object' || sessionStorage.getItem('nomsp') === null ||
            typeof sessionStorage.getItem('idprofilsp') === 'object' || sessionStorage.getItem('idprofilsp') === null ||
            typeof sessionStorage.getItem('idfonctionsp') === 'object' || sessionStorage.getItem('idfonctionsp') === null) {
            this.router.navigate(['/authentication/login']);
        }
      });
  }
}



// WEBPACK FOOTER //
// /Users/numherit/PhpstormProjects/TEMPLATES/sunuprojet/src/app/layout/admin/title/title.component.ts